module.exports = es;

function es () {}

var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
var ObjProto = Object.prototype;
var property = function(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
};
var getLength = property('length');

var isArrayLike = function(collection) {
  var length = getLength(collection);
  return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
};

es.isObject = function(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
};

es.has = function(obj, key) {
  return obj != null && ObjProto.hasOwnProperty.call(obj, key);
};

es.extend = function(obj) {
  var len = arguments.length;
  if (len < 2 || obj == null) return obj;
  var source, idx, k;
  for (idx = 1; idx < len; idx++) {
    source = arguments[idx];
    for (k in source) {
      if (es.has(source, k)) obj[k] = source[k];
    }
  }
  return obj;
};

es.keys = function(obj) {
  if (!es.isObject(obj)) return [];
  if (Object.keys) return Object.keys(obj);
  var keys = [];
  for (var key in obj) if (es.has(obj, key)) keys.push(key);
  return keys;
};

es.each = function(obj, func, context) {
  var iteratee = function() {
    return func.apply(context, arguments);
  };

  var i, length;
  if (isArrayLike(obj)) {
    for (i = 0, length = obj.length; i < length; i++) {
      iteratee(obj[i], i, obj);
    }
  } else {
    var keys = es.keys(obj);
    for (i = 0, length = keys.length; i < length; i++) {
      iteratee(obj[keys[i]], keys[i], obj);
    }
  }
  return obj;
};

es.each(['Function', 'String', 'Number', 'Date'], function(name) {
  es['is' + name] = function(obj) {
    return ObjProto.toString.call(obj) === '[object ' + name + ']';
  };
});

var _multiArgTypeCheck = function (type) {
  return function () {
    var i, len = arguments.length;
    for (i = 0; i < len; i++) {
      if (!es[type](arguments[i])) return false;
    }
    return true;
  };
};

es.inum = _multiArgTypeCheck('isNumber');

es.istr = _multiArgTypeCheck('isString');

// todo: need support ie 6-7 ?
es.stringify = function (json) {
  return JSON.stringify(json);
}


//////////////////
// WEBPACK FOOTER
// ./src/helper/es.js
// module id = 0
// module chunks = 0